export default {
  name: 'marking--reportReportType',
};